import { Injectable } from '@angular/core';
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalitycsService {
  constructor() {}

  trackPage(payload = {}) {
    if (typeof gtag != 'undefined') {
      gtag('event', 'page_view', payload);
    }
  }

  trackConversion(code: string) {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', { send_to: 'AW-11410335507/bvkVCP_AqPcYEJPO78Aq' });
    }
  }

  trackConversionUSD() {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', { send_to: 'AW-11410335507/2vl5CJbXnowZEJPO78Aq' });
    }
  }
}
